import { LuCheck, LuChevronLeft, LuSave } from "react-icons/lu";

// Desktop: the steps as a list. Any step already reached is a button, so
// people can jump back (or forward again) without losing anything.
export function Stepper({ job, steps, index, maxReached, onGo }) {
  return (
    <aside className="cr-apply-side" aria-label="Application steps">
      <div className="cr-apply-role">
        <p>Applying for</p>
        <p>{job.title}</p>
      </div>
      <ol className="cr-stepper">
        {steps.map((step, i) => (
          <li key={step.id}>
            <StepperItem
              step={step}
              number={i + 1}
              current={i === index}
              reachable={i <= maxReached && i !== index}
              done={i < maxReached}
              onGo={() => onGo(step.id)}
            />
          </li>
        ))}
      </ol>
      <p className="cr-apply-note">
        <LuSave aria-hidden="true" />
        Your answers are saved on this device. You can leave and come back.
      </p>
    </aside>
  );
}

function StepperItem({ step, number, current, reachable, done, onGo }) {
  const dot = (
    <span className="cr-stepper-dot" aria-hidden="true">
      {done && !current ? <LuCheck /> : number}
    </span>
  );
  if (reachable) {
    return (
      <button type="button" className="cr-stepper-item" onClick={onGo}>
        {dot}
        {step.short}
      </button>
    );
  }
  return (
    <span className="cr-stepper-item" aria-current={current ? "step" : undefined}>
      {dot}
      {step.short}
    </span>
  );
}

// Phones: a thin bar, the step count and a way back.
export function MobileProgress({ steps, index, onBack, backLabel }) {
  return (
    <div className="cr-progress">
      <div
        className="cr-progress-bar"
        role="progressbar"
        aria-valuemin={1}
        aria-valuemax={steps.length}
        aria-valuenow={index + 1}
        aria-valuetext={`Step ${index + 1} of ${steps.length}: ${steps[index].title}`}
      >
        <span style={{ width: `${((index + 1) / steps.length) * 100}%` }} />
      </div>
      <div className="cr-progress-text">
        <button type="button" className="cr-link-btn cr-progress-back" onClick={onBack}>
          <LuChevronLeft aria-hidden="true" />
          {backLabel}
        </button>
        <span>
          Step {index + 1} of {steps.length}
        </span>
      </div>
    </div>
  );
}
